import { BLOCK_SIZE, GROUND_COLOR, PATH_COLOR, ACTIVE_COLOR } from './utils'
import Tile from './Tile'

class Ground extends Tile {
  constructor(gridSpot) {
    super(gridSpot)
    this.type = 'GROUND'
    this.reset()
  }

  reset() {
    this.f = 0 //total cost function
    this.g = 0 //cost function from start to the current grid point
    this.h = 0 //heuristic estimated cost function from current grid point to the goal
    this.parent = undefined // immediate source of the current grid point

    this.isPartOfPath = false
    this.neighbors = null
  }

  draw(c, isActive) {
    let color = GROUND_COLOR

    if(isActive) {
      color = ACTIVE_COLOR
    } else if(this.isPartOfPath) {
      color = PATH_COLOR
    }

    c.beginPath()
    c.strokeStyle = '#cdcdcd'
    c.rect(this.x, this.y, BLOCK_SIZE, BLOCK_SIZE)
    c.fillStyle = color
    c.fill()
    c.stroke()
    c.closePath()
  }

  update(c, isActive) {
    this.draw(c, isActive)
  }
}

export default Ground
